import notFound from './not-found'
import tplDefault from './tpl-default'
import tplHome from './tpl-home'
import tplManifest from './tpl-manifest'
import tplPartners from './tpl-partners'
import tplExpertises from './tpl-expertises'
import singlePost from './single-post'
import singlePartner from './single-partner'
import singleIndustry from './single-industry'
// import singleExpertise from './single-expertise'
import singleActivity from './single-activity'
import singleWork from './single-work'

export default {
  [notFound.name]: notFound,
  [tplDefault.name]: tplDefault,
  [tplHome.name]: tplHome,
  [tplManifest.name]: tplManifest,
  [tplPartners.name]: tplPartners,
  [tplExpertises.name]: tplExpertises,
  [singlePost.name]: singlePost,
  [singlePartner.name]: singlePartner,
  [singleIndustry.name]: singleIndustry,
  // [singleExpertise.name]: singleExpertise,
  [singleActivity.name]: singleActivity,
  [singleWork.name]: singleWork
}
